import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import ProgramPicker from "../ProgramPicker";

function ProgramGame(props) {
    const {store, color, state, index, progress} = props;

    const group = 'PG';
    return (
        <div className={'Section'}>
            <h1 id={group+'_header'}>Program Game - Prioritization</h1>
            <p className={'bare'}>Which programs do you want to see added to or increased on campus?
                For each desired program, select up to 5 coins. You have a total of 30 coins.
            </p>
            <ProgramPicker store={store} state={state} index={index}
                           color={color} progress={progress}/>
        </div>
    );
}

export default observer(ProgramGame);
